import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { ShieldCheck, RefreshCw } from 'lucide-react';

// Cyber-Security-Übersicht: alle Schutz-Instrumente + Live-Status (aus /admin/security-status).
const BADGE = {
  active:   { label: 'Aktiv',   bg: '#f3e5f5', fg: '#7b1fa2' },
  ready:    { label: 'Bereit',  bg: '#dbeafe', fg: '#1d4ed8' },
  disabled: { label: 'Aus',     bg: '#f3f4f6', fg: '#4b5563' },
  pending:  { label: 'Geplant', bg: '#f3f4f6', fg: '#4b5563' },
  error:    { label: 'Fehler',  bg: '#fee2e2', fg: '#b91c1c' },
};

export default function SecurityDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get('/admin/security-status')
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const s = data?.summary;
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 14, padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <ShieldCheck size={20} color="#9C27B0" />
        <h2 style={{ fontSize: 16, fontWeight: 800, color: '#0a0a0a', flex: 1 }}>Sicherheits-Übersicht</h2>
        <button onClick={load} title="Aktualisieren" style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#f3f4f6', border: 'none', borderRadius: 8, padding: '7px 12px', fontSize: 12, fontWeight: 700, color: '#374151', cursor: 'pointer' }}>
          <RefreshCw size={13} /> Aktualisieren
        </button>
      </div>

      {s && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '4px 0 18px' }}>
          <Pill n={s.active} {...BADGE.active} />
          {s.error > 0 && <Pill n={s.error} {...BADGE.error} />}
          <Pill n={s.pending} {...BADGE.pending} />
          {s.disabled > 0 && <Pill n={s.disabled} {...BADGE.disabled} />}
          <span style={{ fontSize: 12, color: '#6b7280', alignSelf: 'center' }}>von {s.total} Instrumenten</span>
        </div>
      )}

      {loading && <p style={{ color: '#6b7280', fontSize: 13 }}>Lädt …</p>}
      {!loading && !data && <p style={{ color: '#b91c1c', fontSize: 13 }}>Status konnte nicht geladen werden.</p>}

      {data?.groups?.map(g => (
        <div key={g.group} style={{ marginBottom: 18 }}>
          <div style={{ fontSize: 12, fontWeight: 800, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 8 }}>{g.group}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 1, background: '#f3f4f6', borderRadius: 10, overflow: 'hidden' }}>
            {g.items.map((it, i) => {
              const b = BADGE[it.status] || BADGE.disabled;
              return (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: '#fff' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#0a0a0a' }}>{it.name}</div>
                    <div style={{ fontSize: 12, color: '#4b5563' }}>{it.desc}{it.detail ? ` · ${it.detail}` : ''}</div>
                  </div>
                  <span style={{ flexShrink: 0, fontSize: 12, fontWeight: 800, color: b.fg, background: b.bg, padding: '4px 12px', borderRadius: 999 }}>{b.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

function Pill({ n, label, bg, fg }) {
  return <span style={{ fontSize: 12, fontWeight: 800, color: fg, background: bg, padding: '4px 12px', borderRadius: 999 }}>{n} {label}</span>;
}
